import { useQuery } from '@tanstack/react-query';

import { accountSwitchesApi } from '../axios';

export const LINKED_ACCOUNTS_QUERY_KEY = ['linkedAccounts'];

/**
 * How long the list is trusted without asking again. Which accounts a person
 * belongs to changes on the order of days, and the cost of it being a few
 * minutes stale is that a just-granted account is missing until the next open.
 */
const LINKED_ACCOUNTS_STALE_MS = 5 * 60 * 1000;

/**
 * `enabled` skips the request when the session is not ready yet, or when the
 * account does not have the feature. For the vast majority of users the answer
 * would be an empty list.
 *
 * `staleTime` is what keeps the menu from growing under the pointer: with the
 * default of 0 every open refetches, the switcher renders nothing while it does,
 * and the items already on screen jump down when the answer lands, right on top
 * of Log out.
 */
export function useLinkedAccountsQuery(enabled = true) {
  return useQuery({
    queryKey: LINKED_ACCOUNTS_QUERY_KEY,
    queryFn: accountSwitchesApi.getLinkedAccounts,
    enabled,
    staleTime: LINKED_ACCOUNTS_STALE_MS,
  });
}
